export default __webpack_public_path__ + "static/media/014-barrier.511d73b8.png";